import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyringe } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";

import TablaHomeosiniartia from "./TablaHomeosiniatria";

const Homeosiniartia = () => {
  return (
    <Card>
      <Card.Header
        style={{
          backgroundColor: "#F5E6D3",
          color: "#5E8C5A",
          fontWeight: "bold",
        }}
        as="h3"
      >
        Homeosiniatria <FontAwesomeIcon icon={faSyringe} />
      </Card.Header>
      <Card.Body>
        <TablaHomeosiniartia />
      </Card.Body>
    </Card>
  );
};

export default Homeosiniartia;
